import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'isSame' })
export class IsSamePipe implements PipeTransform {
  transform(a: any, b: any) {
    return JSON.stringify(a) === JSON.stringify(b);
  }
}
